<div class="d-inline-flex">
                <span
                  class="pe-2 fw-bold fs-12 line-height-1">{{
                    currentDate ? (currentDate | localizedDate:'dd.MM.yyyy') : '-'
                  }}</span>
</div>
<div class="d-flex align-content-end">
  <!-- Display the time in HH:mm:ss.SSS format with milliseconds -->
  <ng-container *ngIf="currentDate">
                  <span *ngFor="let char of (currentDate | localizedDate:'HH:mm:ss').split(''); let i = index">
                    <span *ngIf="i >= 9" class="milliseconds-char">{{ char }}</span>
                    <span *ngIf="i < 9 && char !== ':' && char !== '.'" class="time-char">{{ char }}</span>
                    <span *ngIf="char === ':' || char === '.'" class="time-separator">{{ char }}</span>
                  </span>
  </ng-container>
</div>
